module.exports = __webpack_public_path__ + "0f93223ba8d4db41bd1a0ae47f901756.svg";